import React from "react";

const TopperIconBadge = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    {...props}
  >
    <g
      style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
    >
      <path
        d="M 80.386 77.959 L 69.929 55.535 c -6.21 6.668 -15.038 10.862 -24.833 10.922 l 10.708 22.965 c 0.135 0.289 0.399 0.497 0.712 0.559 c 0.066 0.014 0.131 0.02 0.196 0.02 c 0.249 0 0.49 -0.092 0.677 -0.263 l 9.477 -8.683 l 12.742 -1.678 c 0.316 -0.041 0.594 -0.231 0.748 -0.511 C 80.51 78.585 80.521 78.248 80.386 77.959 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          fill: "rgb(79,213,206)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        strokeLinecap="round"
      />
      <path
        d="M 44.886 66.462 c -9.8 0 -18.644 -4.145 -24.89 -10.767 L 9.614 77.959 c -0.135 0.29 -0.124 0.626 0.029 0.906 c 0.154 0.28 0.432 0.47 0.748 0.511 l 12.742 1.678 l 9.476 8.683 C 32.797 89.908 33.039 90 33.287 90 c 0.065 0 0.131 -0.006 0.196 -0.02 c 0.313 -0.062 0.577 -0.27 0.712 -0.559 l 10.707 -22.96 C 44.897 66.462 44.892 66.462 44.886 66.462 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          fill: "rgb(79,213,206)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        strokeLinecap="round"
      />
      <path
        d="M 50.871 41.396 h -1.13 c -1.186 0 -2.149 -0.964 -2.149 -2.15 V 18.809 c 0 -0.03 0 -0.1 -0.093 -0.139 s -0.142 0.011 -0.163 0.032 l -8.313 8.313 c -0.058 0.059 -0.058 0.154 0 0.213 l 2.336 2.335 c 0.05 0.05 0.162 0.05 0.212 0 l 2.417 -2.417 v 12.1 c 0 1.186 -0.964 2.15 -2.15 2.15 h -1.129 c -0.083 0 -0.15 0.067 -0.15 0.15 v 3.304 c 0 0.083 0.067 0.15 0.15 0.15 h 10.163 c 0.082 0 0.149 -0.067 0.149 -0.15 v -3.304 C 51.021 41.464 50.953 41.396 50.871 41.396 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          fill: "rgb(79,213,206)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        strokeLinecap="round"
      />
      <path
        d="M 44.886 0 c -12.75 0 -23.768 7.405 -28.995 18.148 c -2.032 4.224 -3.172 8.955 -3.172 13.947 c 0 8.262 3.123 15.805 8.247 21.521 l -0.064 0.137 c 5.9 6.571 14.458 10.706 23.984 10.706 c 17.8 0 32.229 -14.429 32.229 -32.229 S 62.686 0 44.886 0 z M 45 55.015 c -12.638 0 -22.921 -10.282 -22.921 -22.92 c 0 -0.553 0.449 -1.002 1.002 -1.002 s 1.002 0.449 1.002 1.002 c 0 11.533 9.383 20.916 20.917 20.916 c 0.553 0 1.002 0.448 1.002 1.002 S 45.553 55.015 45 55.015 z M 53.021 44.85 c 0 1.185 -0.964 2.15 -2.149 2.15 H 40.708 c -1.186 0 -2.15 -0.965 -2.15 -2.15 v -3.304 c 0 -1.186 0.964 -2.15 2.15 -2.15 h 1.129 c 0.083 0 0.15 -0.067 0.15 -0.15 v -7.703 c -0.713 0.178 -1.511 -0.034 -2.043 -0.567 l -2.336 -2.335 c -0.838 -0.838 -0.838 -2.202 0 -3.04 l 8.313 -8.313 c 0.616 -0.617 1.534 -0.8 2.342 -0.466 c 0.807 0.334 1.328 1.114 1.328 1.986 v 20.438 c 0 0.083 0.067 0.15 0.149 0.15 h 1.13 c 1.186 0 2.149 0.964 2.149 2.15 V 44.85 z M 66.918 33.096 c -0.554 0 -1.002 -0.449 -1.002 -1.002 c 0 -11.534 -9.383 -20.917 -20.916 -20.917 c -0.553 0 -1.002 -0.449 -1.002 -1.002 S 44.447 9.173 45 9.173 c 12.638 0 22.92 10.282 22.92 22.921 C 67.92 32.648 67.472 33.096 66.918 33.096 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          fill: "rgb(79,213,206)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default TopperIconBadge;